export default __webpack_public_path__ + "static/media/Frame1.2e3aa590.svg";